"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = void 0;
var col_1 = require("./col");
Object.defineProperty(exports, "Col", { enumerable: true, get: function () { return __importDefault(col_1).default; } });
